module.exports = __webpack_public_path__ + "static/fonts/icons.c08753f.ttf";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/dist/src/fonts/icons.ttf
// module id = CwA1
// module chunks = 1